export function getPropsForRecommendations({
  navigationLevel,
  campaignType,
}) {
  return {
    navigationLevel,
    campaignType,
  };
}
